import { __read } from 'tslib';
import * as React from 'react';
import classNames from 'classnames';
import 'react-autosuggest';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import '@invitae/ids-react';
import '../../common/VideoPopupLink/VideoPopup/VideoPopup.esm.js';
import '@invitae/add-to-cart';
import '@invitae/nucleobase-engine-contentful';
import '../../contexts/GlobalActionsContext/GlobalActionsContext.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import '@invitae/nucleobase-analytics';
import '../../common/ContentfulImage/ContentfulImage.esm.js';
import '../../hooks/animation/animationContext.esm.js';
import '../../hooks/animation/classManipulation.esm.js';
import '../../types/animation.esm.js';
import '../../common/ContentfulImage/ImageContext.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import '../../common/WrappedVideo/NvVideo/NvVideo.esm.js';
import '../../common/WrappedVideo/Vimeo/Vimeo.esm.js';
import 'react-dom';
import 'luxon';
import 'use-debounce';
import '../../GlobalTextCopyContext/GlobalTextCopyContext.esm.js';
import CarouselItemWrapper from '../../common/CarouselProvider/CarouselItemWrapper/CarouselItemWrapper.esm.js';
import CarouselProvider from '../../common/CarouselProvider/CarouselProvider.esm.js';
import { v4 } from 'uuid';
import styles from './CarouselSection.module.esm.js';

var CarouselSection = function (_a) {
    var fields = _a.fields, id = _a.id, dataCy = _a["data-cy"];
    var items = fields.items, accessibleHeading = fields.accessibleHeading, internalName = fields.internalName, theme = fields.theme, heading = fields.heading, subheading = fields.subheading;
    var _b = __read(React.useState(''), 2), carouselId = _b[0], setCarouselId = _b[1];
    React.useEffect(function () {
        // As uuidv4 is not deterministic it needs to be set on the client side
        // to avoid SSR problems
        setCarouselId(v4());
    }, []);
    if (items.length <= 1) {
        return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(styles.carouselSection, styles[theme]), "data-cy": dataCy, id: id, sectionName: internalName },
            heading && (React.createElement(BaseHeading, { className: styles.heading, heading: heading, headingAlignment: "center", subheading: subheading })),
            items[0] && React.createElement(BaseNucleobaseComponent, { source: items[0] })));
    }
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: classNames(styles.carouselSection, styles[theme]), "data-cy": dataCy, id: id, sectionName: internalName },
        heading && (React.createElement(BaseHeading, { body: subheading, className: styles.heading, heading: heading, headingAlignment: "center" })),
        React.createElement(CarouselProvider, { accessibleHeading: accessibleHeading, carouselId: carouselId, items: items, showDots: true }, items.map(function (item, index) { return (React.createElement(CarouselItemWrapper, { carouselId: carouselId, index: index, key: item.sys.id, numberOfItems: items.length, shouldCheckForWidth: false, theme: theme },
            React.createElement(BaseNucleobaseComponent, { source: item }))); }))));
};

export { CarouselSection as default };
//# sourceMappingURL=CarouselSection.esm.js.map
